import { render, staticRenderFns } from "./ZipTaxRate.vue?vue&type=template&id=bcfe27c6&scoped=true"
import script from "./ZipTaxRate.vue?vue&type=script&lang=js"
export * from "./ZipTaxRate.vue?vue&type=script&lang=js"
import style0 from "./ZipTaxRate.vue?vue&type=style&index=0&id=bcfe27c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfe27c6",
  null
  
)

export default component.exports